import Container from './editable/Container.js';
import Input from './editable/Input.js';
import notification from 'notification-js';
import getYouTubeID from 'get-youtube-id';
import Sortable from 'sortablejs';

export const mapping = ({data, path}) => {
  return {
    tutorials: data.tutorials
  }
}

export const transform = ({modal, path, updateState}) => {
  return {
    tutorials: {
      dom: '.editor-fields-tutorials',
      callback: function() {
        let editorFields = modal.el.getElementsByClassName('editor-fields')[0];
        editorFields.__dirty = false;

        let tutorialsElement = modal.el.getElementsByClassName('slide-edit');
        this.tutorials.forEach((tutorial, index) => {

          let tutorialElement = new Container({element: tutorialsElement[index],
                                              editable: true,
                                              data: this.tutorials,
                                              index,
                                              updateState,
                                              onDelete: deleteTutorial});

          const updateTextValue = (key, value) => {
            editorFields.__dirty = true;
            tutorial[key] = value;
            updateState();
          };

          tutorialElement.getField('name').onkeyup = (event) => {updateTextValue('name', event.target.value)};
          tutorialElement.getField('url').onkeyup = (event) => {updateTextValue('url', event.target.value)};
          tutorialElement.getField('summary').onkeyup = (event) => {updateTextValue('summary', event.target.value)};
        });

        var sortable = new Sortable(editorFields, {
        	group: "videoguides",
        	sort: true,  // sorting inside list
        	delay: 0, // time in milliseconds to define when the sorting should start
        	animation: 150,  // ms, animation speed moving items when sorting, `0` — without animation
        	draggable: ".field-item-container",
        	scroll: true, // or HTMLElement
        	scrollSensitivity: 30, // px, how near the mouse must be to an edge to start scrolling.
        	scrollSpeed: 10, // px
          filter: "input, textarea",
        	// Called by any change to the list (add / update / remove)
        	onSort: function (evt) {

            this.tutorials.splice(evt.oldIndex, 0, this.tutorials.splice(evt.newIndex, 1)[0]);
            updateState();
        		// same properties as onUpdate
        	}.bind(this),

        });
      },
      transform: (tutorial) => {
        return `<div class="field-item-container autoHeight">
          <div class="slide slide-edit max350">
            <input type="text" name="name" class="name" value="` + tutorial.name + `">
            <input type="text" name="url" class="url" value="` + tutorial.url + `">
            <textarea class="summary">${tutorial.summary}</textarea>
            <a href="#" class="delete" style="display:none;">Delete</a>
          </div>
        </div>`;
      }
    }
  }
}

export const loadForm = ({modal, editor, data, path, updateState}) => {
  let addSlideButton = modal.el.getElementsByClassName("addSlide")[0];

  addSlideButton.onclick = (event) => {
    addTutorial(event, modal, editor.tutorials, updateState);
  }
};

export const getData = (currentState, editor) => {
  currentState.tutorials = [];

  editor.tutorials.forEach((tutorial, index) => {
    let newTutorial = {};
    newTutorial.name = tutorial.name;
    newTutorial.summary = tutorial.summary;
    var id = getYouTubeID(tutorial.url);

    newTutorial.url = "https://www.youtube.com/embed/" + id;
    currentState.tutorials.push(newTutorial);
  });

  return currentState;
}

const deleteTutorial = (event, tutorials, index, updateState) => {
  event.preventDefault();
  if (tutorials.length > 1) {
    tutorials.splice(index, 1);
    updateState();
  } else {
    notification.notify( 'error', 'Unable to delete last tutorial', {
      notification: {position: [ 'right', 'top' ]}
    });
  }
}

const addTutorial = (event, modal, tutorials, updateState) => {
  event.preventDefault();
  tutorials.push({name: 'Enter name',
                  url: 'Add link to video',
                  summary: 'Add tutorial summary here'});
  let editorFields = modal.el.getElementsByClassName('editor-fields')[0];

  editorFields.scrollLeft = editorFields.offsetWidth;
  updateState();
}

export default function() {
  let template = `
    <div class="form">
      <div class="editor-fields editor-fields-tutorials">
      </div>
      <div class="field-item-container add-more">
        <div class="slide">
          <a href="#" class="addSlide">+</a>
        </div>
      </div>
    </div>
  `

  return `<div>
    ${template}
  </div>`;
};



// WEBPACK FOOTER //
// ./src/editors/VideoGuides.js